"use client";

import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { consumeSkipLinkFocusResetSuppression } from "@/utils/skip-link-focus";

const SkipLink = () => {
  const [isServer, setIsServer] = useState(true);

  const pathname = usePathname();

  useEffect(() => {
    setIsServer(false);
  }, []);

  useEffect(() => {
    if (consumeSkipLinkFocusResetSuppression()) return;

    document.body.setAttribute("tabindex", "-1");
    document.body.focus({ preventScroll: true });

    const cleanup = () => {
      document.body.removeAttribute("tabindex");
    };

    document.body.addEventListener("blur", cleanup, { once: true });

    return () => {
      document.body.removeEventListener("blur", cleanup);
      cleanup();
    };
  }, [pathname]);

  const onClick = () => {
    const container = document.querySelector(
      "#main-content"
    ) as HTMLElement | null;
    const header = document.querySelector("#header") as HTMLElement | null;

    if (container) {
      // Only a sticky header covers the content; at short viewports
      // (globals.css) it scrolls away with the page instead.
      const headerPosition = header ? getComputedStyle(header).position : "";
      const headerHeight =
        headerPosition === "sticky" || headerPosition === "fixed"
          ? header?.offsetHeight || 0
          : 0;
      const containerTop =
        container.getBoundingClientRect().top + window.pageYOffset;
      const scrollPosition = containerTop - headerHeight;

      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });

      container.setAttribute("tabindex", "-1");
      container.focus({ preventScroll: true });

      container.addEventListener(
        "blur",
        () => {
          container.removeAttribute("tabindex");
        },
        { once: true }
      );
    }
  };

  if (isServer) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      className="absolute z-50 opacity-0 rounded-none btn btn-comp transition-all -translate-y-full focus:translate-y-0 focus:opacity-100"
    >
      Gå till innehåll
    </button>
  );
};

export default SkipLink;
